<template>
    <div id="product-info-page">
        <div class="top-buttons">
            <ui5-button
                @click="save"
                :disabled="!product || !reasons"
            >
                {{ trans('pages.product_info.save') }}
            </ui5-button>
            <ui5-button @click="$router.push('/productpage/' + idParam)">
                {{ trans('pages.product_info.cancel') }}
            </ui5-button>
        </div>

        <spinner-text v-if="!product || !reasons">
            {{ trans('pages.product_info.loading') }}
        </spinner-text>
        <div
            class="fields"
            v-else
        >
            <div class="field">
                <ui5-label for="productinfoboxnr">
                    {{ trans('pages.product_info.box_nr') }}
                </ui5-label>
                <ui5-input
                    :value="product.boxnr"
                    @input="product.boxnr = $event.target.value"
                    id="productinfoboxnr"
                />
            </div>
            <div class="field">
                <ui5-label for="productinfocolli">
                    {{ trans('pages.product_info.colli') }}
                </ui5-label>
                <ui5-input
                    :value="product.colli"
                    @input="product.colli = $event.target.value"
                    id="productinfocolli"
                />
            </div>
            <div class="field">
                <ui5-label for="productinfoproductiondate">
                    {{ trans('pages.product_info.production_date') }}
                </ui5-label>
                <ui5-date-picker
                    id="productinfoproductiondate"
                    format-pattern="yyyy-MM-dd"
                    :value="product.productionDate"
                    @change="product.productionDate = $event.target.value"
                />
            </div>
            <div class="field">
                <ui5-label for="productinforepairreason">
                    {{ trans('pages.product_info.repair_reason') }}
                </ui5-label>
                <ui5-select
                    @change="
                        product.repairreasonId =
                            $event.detail.selectedOption.value
                    "
                    id="productinforepairreason"
                >
                    <ui5-option
                        v-for="reason in reasons"
                        :key="'reason.' + reason.repairreasonId"
                        :value="reason.repairreasonId"
                        :selected="
                            reason.repairreasonId == product.repairreasonId
                        "
                    >
                        {{ reason.description }}
                    </ui5-option>
                </ui5-select>
            </div>
            <div class="field">
                <ui5-label for="productinfointernurl">
                    {{ trans('pages.product_info.internal_url') }}
                </ui5-label>
                <ui5-input
                    :value="product.internUrl"
                    @input="product.internUrl = $event.target.value"
                    id="productinfointernurl"
                />
            </div>
            <div class="field">
                <ui5-label for="productinfoexternurl">
                    {{ trans('pages.product_info.external_url') }}
                </ui5-label>
                <ui5-input
                    id="productinfoexternurl"
                    :value="product.externUrl"
                    @input="product.externUrl = $event.target.value"
                />
            </div>
        </div>
    </div>
</template>
<script>
import productApi from '../api/product';
import SpinnerText from '../components/loader/SpinnerText';
import IdParamMixin from '../mixins/id-param';
import { isNumber } from '../helpers/GeneralHelper';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), localization],
    components: { SpinnerText },
    data() {
        return {
            product: null,
            reasons: null,
        };
    },
    methods: {
        save() {
            const colli = this.product.colli;
            if (colli != '' && (!isNumber(colli) || colli <= 0)) {
                return showErrorMessage(
                    this.trans('pages.product_info.invalid_colli_error')
                );
            }
            productApi.setAdditionalInfoToProduct(
                this.idParam,
                this.product.boxnr,
                colli,
                this.product.productiondate,
                this.product.repairreasonId,
                this.product.internUrl,
                this.product.externUrl
            );
            this.$router.push('/productpage/' + this.idParam);
        },
        load() {
            this.$store.commit(
                'general/setPageTitle',
                this.trans('pages.product_info.page_title', {
                    productId: this.idParam,
                }),
                { root: true }
            );
            productApi.getAdditionalInfo(this.idParam).then((response) => {
                const product = response.data.data;
                this.product = product;
                this.reasons = [
                    {
                        repairreasonId: null,
                        description: this.trans(
                            'pages.product_info.default_option'
                        ),
                    },
                    ...product.reasons,
                ];
            });
        },
    },
};
</script>
